import { observable } from "mobx";
import { Type } from "class-transformer";
import { formatDate, translateEnum } from "../utils/localizations";
import Optionable from "../utils/optionable";
import DistributorPaymentRequestType from "./distributorPaymentRequestType";

@Optionable((distributorPaymentRequest: DistributorPaymentRequestResponse) => ({
  id: distributorPaymentRequest.id,
  label: `${distributorPaymentRequest.variableSymbol} - ${formatDate(distributorPaymentRequest.validUntilDate)} - ${translateEnum(
    "distributorPaymentRequestType",
    distributorPaymentRequest.type
  )}`,
}))
// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class DistributorPaymentRequestResponse {
  id!: string;

  @observable
  distributorId!: string;

  @observable
  type!: DistributorPaymentRequestType;

  @observable
  @Type(() => Date)
  validSinceDate?: Date;

  @observable
  @Type(() => Date)
  validUntilDate!: Date;

  @observable
  variableSymbol!: number;
}
